import {l} from "types/typescriptdefinisjoner_lederplan";
import {OppgaveRessurs, OppgavestatusBeregnet} from "../tjenester/ressurser/OppgaveRessurs";

export function oppgaveAvatarKlasseFilterForInjisering() {
    return [oppgaveAvatarKlasseFilter];
}

export function oppgaveAvatarKlasseFilter(): Function {
    return function (oppgave: l.OppgaveModell): string {
        var s = OppgavestatusBeregnet;
        switch (OppgaveRessurs.oppgaveStatus2(oppgave)) {
            case s.ikkeoverskredet:
                return "";
            case s.overskredet:
                return "roed";
            case s.overskrides:
                return "roed";
            case s.utfoert:
                return "groenn";
        }
    };
}
